// src/middleware/productStatusMiddleware.js
// Middleware to select and call the correct fetch for each product

import { fetchCxpServicesStatus } from '../actions/cxp.js';
import { fetchAsapServicesStatus } from '../actions/asap.js';
// import other product fetchers here as needed

/**
 * Placeholder function for products not yet implemented
 */
async function fetchPlaceholderStatus(productName) {
  // Simulate a delay to show loading state
  await new Promise(resolve => setTimeout(resolve, 500));
  
  return [
    {
      name: `${productName} Service`,
      status: 'Unknown',
      lastChecked: new Date(),
      note: 'Status monitoring for this product is not yet implemented.'
    }
  ];
}

/**
 * Fetches status for the specified product
 * @param {string} product - Product name (CXP, ASAP, VancoEvents)
 * @returns {Promise<Array>} Array of service status objects
 */
export async function fetchStatusForProduct(product) {
  switch (product) {
    case 'CXP':
      return await fetchCxpServicesStatus();
    case 'ASAP':
      return await fetchAsapServicesStatus();
    case 'VancoEvents':
      return await fetchPlaceholderStatus('VancoEvents');
    default:
      throw new Error(`Unknown product: ${product}. Available products: CXP, ASAP, VancoEvents`);
  }
}
